export const semesters = [
    { year: 2022, sem: 1, label: '1 семестр 2022/2023 года' },
    { year: 2022, sem: 2, label: '2 семестр 2022/2023 года' },
    { year: 2023, sem: 1, label: '1 семестр 2023/2024 года' },
];
